var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 91,
    viewBox: "0 0 68 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.98 23.725L43.18 0.975C42.5 0.325 41.82 0 40.8 0L6.8 0C3.06 0 0 2.925 0 6.5L0 84.5C0 88.075 3.06 91 6.8 91L61.2 91C64.94 91 68 88.075 68 84.5L68 26C68 25.025 67.66 24.375 66.98 23.725ZM40.8 7.8L59.84 26L40.8 26L40.8 7.8ZM61.2 84.5L6.8 84.5L6.8 6.5L34 6.5L34 26C34 29.575 37.06 32.5 40.8 32.5H61.2L61.2 84.5Z",
    fill: "#0C7488"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 65L54.4 65L54.4 71.5L13.6 71.5V65ZM13.6 45.5L54.4 45.5V52L13.6 52L13.6 45.5Z",
    fill: "#0C7488"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.6c6a9894a9722a356089f5a233c414b0.svg";
export { ForwardRef as ReactComponent };